import { Component } from '@angular/core';
import { ApplicationUser } from './../../../services/ApplicationUser';
import { Router } from '@angular/router';
import { smoothlyMenu } from '../../../app.helpers';
import { ModalWinNewLeadService } from '../../../views/modal-win-new-lead/win.service';
import {LastUrl} from '../../../services/LastRouteService';
import {PricingsService} from '../../../models/pricings/pricings.service';
import {PermissionsService} from "../../../services/permissions/permissions.service";

declare var jQuery:any;


@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html',
    styleUrls: ['style.css']
})
export class TopnavbarComponent {
    constructor (
        private router: Router,
        public permission: PermissionsService,
    ) {}

    logout() {
        const user = ApplicationUser.getInstance();
        user.logout();
        LastUrl.setNew();
        this.router.navigate(['/login']);
    }

    toggleNavigation(): void {
        jQuery("body").toggleClass("mini-navbar");
        smoothlyMenu();
    }

    showAddLead() {
        ModalWinNewLeadService.getInstance().show();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/topnavbar/topnavbar.component.ts